import React, { useState } from "react";
import "./HomePage.scss";
import { work } from "../../Utility/Work";
import { Fade } from "react-awesome-reveal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import {
  faLinkedin,
  faAndroid,
  faApple,
  faReact,
} from "@fortawesome/free-brands-svg-icons";
import { myProjects } from "../../Utility/Projects";
import { faq } from "../../Utility/Faq";
import HeaderDark from "../../Layouts/Dark/HeaderDark";

export const ourServices = [
  {
    number: "01",
    title: "Cross platform",
    description: (
      <div>
        Our mobile apps are built once and target both iOS and Android
        platforms. We use react native.
        <div style={{ float: "right" }}>
          <FontAwesomeIcon icon={faApple} />
          &nbsp;
          <FontAwesomeIcon icon={faAndroid} />
          &nbsp;
          <FontAwesomeIcon icon={faReact} />
        </div>
      </div>
    ),
  },
  {
    number: "02",
    title: "Reusable components",
    description: (
      <div>
        Prebuilt components are included to save time and development costs.
      </div>
    ),
  },
  {
    number: "03",
    title: "Experienced team",
    description: (
      <div>
        We are a small team of experienced professionals and are 100% based in
        Australia.{" "}
        <img
          src="assets/images/kangaroo-inverted.png"
          alt="Australia"
          style={{ height: "20px", display: "inline" }}
        />
      </div>
    ),
  },
  {
    number: "04",
    title: "Maintenance & Support",
    description: <div>We offer ongoing support and updates.</div>,
  },
];

const NewHomePage = () => {
  const [isQAOpen, setIsQAOpen] = useState<number | null>(null);

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (!section) return;

    const navbarHeight = 70;
    const sectionPosition = section.offsetTop - navbarHeight;
    window.scrollTo({
      top: sectionPosition,
      behavior: "smooth",
    });
  };

  return (
    <div className="freelancer-page">
      {/* Fixed Navbar */}
      <HeaderDark />

      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <Fade triggerOnce duration={1000} direction="up">
            <div className="hero-content">
              <div className="hero-text">
                <div className="typing-div">
                  <div className="typewriter">
                    <h1>We build apps&nbsp;</h1>
                  </div>
                </div>
                <p className="hero-description">
                  Build once and deploy to Apple and Android
                </p>
                <div className="hero-icons">
                  <FontAwesomeIcon
                    icon={faApple}
                    fontSize={40}
                    style={{ color: "silver" }}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <FontAwesomeIcon
                    icon={faAndroid}
                    fontSize={40}
                    style={{ color: "silver" }}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <button
                    className="hero-explore-button"
                    onClick={() => scrollToSection("features")}
                  >
                    <FontAwesomeIcon icon={faChevronDown} />
                    &nbsp;Explore
                  </button>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="services-section">
        <div className="container">
          <Fade triggerOnce duration={1000} direction="up">
            <div className="section-header">
              <h2 className="section-title">Features</h2>
              <p className="section-subtitle">What We Offer</p>
            </div>
          </Fade>
          <div className="services-grid">
            {ourServices.map((service, index) => (
              <Fade
                key={index}
                triggerOnce
                duration={1000}
                delay={index * 100}
                direction="up"
              >
                <div className="service-card">
                  <div className="service-number">{service.number}</div>
                  <h3 className="service-title">{service.title}</h3>
                  <div className="service-description">
                    {service.description}
                  </div>
                </div>
              </Fade>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section id="process" className="process-section">
        <div className="container">
          <Fade triggerOnce duration={1000} direction="up">
            <div className="section-header">
              <h2 className="section-title">Process</h2>
              <p className="section-subtitle">How We Work</p>
            </div>
          </Fade>
          <div className="process-grid">
            {work.map((step, index) => (
              <Fade
                key={index}
                triggerOnce
                duration={1000}
                delay={index * 100}
                direction="up"
              >
                <div className="process-card">
                  <div className="process-icon">{step.faIcon}</div>
                  <h3 className="process-title">{step.title}</h3>
                  <div className="process-description">{step.description}</div>
                </div>
              </Fade>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="calculator" className="cta-section">
        <div className="container">
          <Fade triggerOnce duration={1000} direction="up">
            <div className="cta-content">
              <h2 className="cta-title">Ready to Build Your App?</h2>
              <p className="cta-subtitle">
                Get an instant estimate for your project with our interactive
                price calculator
              </p>
              <Link to="/calculator" className="cta-button">
                Try our calculator
                <span className="cta-arrow">→</span>
              </Link>
            </div>
          </Fade>
        </div>
      </section>

      {/* Projects Section */}
      <section id="projects" className="portfolio-section">
        <div className="container">
          <Fade triggerOnce duration={1000} direction="up">
            <div className="section-header">
              <h2 className="section-title">Recent Projects</h2>
              {/* <p className="section-subtitle">Recent Work</p> */}
            </div>
          </Fade>
          <div className="portfolio-grid row">
            {myProjects.filter(app => !app.hidden).map((app, index) => (
              <Fade
                key={index}
                triggerOnce
                duration={1000}
                delay={index * 100}
                direction="up"
              >
                <div className="portfolio-card col-md-4 col-12">
                  {/* <a
                      href={app.playStoreUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="portfolio-card"
                    > */}
                  {app.icon ? (
                    <div className="portfolio-image">
                      <img src={app.icon} alt={`${app.name} icon`} />
                    </div>
                  ) : (
                    <div className="portfolio-image">
                      <div className="app-icon-placeholder">
                        <span>{app.name.charAt(0)}</span>
                      </div>
                    </div>
                  )}
                  <div className="portfolio-content">
                    <h3 className="portfolio-title">{app.name}</h3>
                    <p className="portfolio-description">{app.description}</p>
                    <div className="portfolio-store-badges">
                      {app.appleAppStoreUrl && (
                        <a
                          href={app.appleAppStoreUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="assets/images/apple-app-store-badge.svg"
                            alt="Apple App Store"
                            className="store-badge"
                          />
                        </a>
                      )}
                      {app.playStoreUrl && (
                        <a
                          href={app.playStoreUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src="assets/images/google-play-badge.svg"
                            alt="Google Play Store"
                            className="store-badge"
                          />
                        </a>
                      )}
                    </div>
                  </div>
                  {/* </a> */}
                </div>
              </Fade>
            ))}
          </div>
        </div>
      </section>

      {/* Q&A Section */}
      <section id="qa" className="qa-section">
        <div className="container">
          <Fade triggerOnce duration={1000} direction="up">
            <div className="section-header">
              <h2 className="section-title">Q&A</h2>
              <p className="section-subtitle">Frequently Asked Questions</p>
            </div>
          </Fade>
          <Fade triggerOnce duration={1000} delay={200} direction="up">
            <div className="qa-accordion">
              {faq.map((data, index) => (
                <div key={index} className="qa-item">
                  <button
                    onClick={() =>
                      setIsQAOpen(isQAOpen === index ? null : index)
                    }
                    className={`qa-question ${isQAOpen === index ? "active" : ""}`}
                    type="button"
                    aria-expanded={isQAOpen === index ? "true" : "false"}
                  >
                    {data.question}
                    <span className="qa-icon">
                      {isQAOpen === index ? "−" : "+"}
                    </span>
                  </button>
                  <div
                    className={`qa-answer ${isQAOpen === index ? "open" : ""}`}
                  >
                    <p>{data.ans}</p>
                  </div>
                </div>
              ))}
            </div>
          </Fade>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="contact-section">
        <div className="container">
          <Fade triggerOnce duration={1000} direction="up">
            <div className="section-header">
              <h2 className="section-title">Contact</h2>
              {/* <p className="section-subtitle">Let's Work Together</p> */}
            </div>
          </Fade>
          <Fade triggerOnce duration={1000} delay={200} direction="up">
            <div className="contact-content">
              <div className="contact-info">
                <div className="contact-item">
                  <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                  <a href="mailto:hello@silveridea.app">hello@silveridea.app</a>
                </div>
                <div className="contact-item">
                  <FontAwesomeIcon icon={faLinkedin} className="contact-icon" />
                  <a
                    href="https://www.linkedin.com/company/silveridea"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    linkedin.com/company/silveridea
                  </a>
                </div>
              </div>
              <div className="contact-footer">
                <p>© 2017 - 2026 | Silveridea | ABN:95773864159</p>
              </div>
            </div>
          </Fade>
        </div>
      </section>
    </div>
  );
};

export default NewHomePage;
